import React from 'react';

import { Link } from 'Components/molecules/Link';

const onClickHandler = (id) => {
  const el = document.getElementById(id);
  el.tabIndex = 0;
  el.focus();
  el.tabIndex = -1;
};

export const getSkipLinkComponent = () => (
  <>
    <Link href="#header" onClick={() => onClickHandler('header')} extraClassNames={{ '-header': true, 'skip-to': true }}>Skip to header</Link>
    <Link href="#main" onClick={() => onClickHandler('main')} extraClassNames={{ '-main': true, 'skip-to': true }}>Skip to main content</Link>
    <Link href="#footer" onClick={() => onClickHandler('footer')} extraClassNames={{ '-footer': true, 'skip-to': true }}>Skip to footer</Link>
  </>
);
